module.exports = __webpack_public_path__ + "./images/96ecc2cbf6ad7ff6996618a502f164ee.webp";